import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ControlContainer, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ProjectSchedule } from 'core/http/root';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { TimeHelper } from 'shared/common/types';
import { LabelPipe } from 'shared/modules/pipes/label.pipe';
import { ProjectScheduleDialogComponent } from './project-schedule-dialog/project-schedule-dialog.component';

@Component({
  selector: 'app-withdrawn-select',
  templateUrl: './withdrawn-select.component.html',
  styleUrls: ['./withdrawn-select.component.scss'],
  providers: [LabelPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WithdrawnSelectComponent {
  get schedules(): UntypedFormControl {
    return (<UntypedFormGroup> this.container.control).controls.withdrawnSchedules as UntypedFormControl;
  }

  get schedulesValue(): ProjectSchedule[] {
    return this.schedules.value;
  }

  constructor(
    private container: ControlContainer,
    private dialog: MatDialog,
    private labelPipe: LabelPipe,
  ) { }

  openScheduleDialog(i?: number): void {
    const data = i !== undefined
      ? this.schedulesValue[i]
      : undefined;

    this.dialog.open(ProjectScheduleDialogComponent, { data })
      .afterClosed()
      .pipe(first())
      .subscribe((schedule: ProjectSchedule | null) => {
        if (!schedule) {
          return;
        }

        const { hour, minute } = TimeHelper.fromLocalToUtc(schedule.hour, schedule.minute);
        const formatted = { ...schedule, hour, minute };

        const value = [...this.schedulesValue];

        i !== undefined
          ? value.splice(i, 1, formatted)
          : value.push(formatted);

        this.schedules.setValue(value);
      });
  }

  convertTime(h: number, m: number): string {
    const { hour, minute } = TimeHelper.fromUtcToLocal(h, m);

    const prettyMinute = minute <= 9 && minute >= 0 ? `0${minute}` : minute;
    return `${hour}:${prettyMinute}`;
  }

  removeSchedule(i: number): void {
    this.schedules.setValue(this.schedulesValue.filter((_, idx) => i !== idx));
  }

  getDaysLabel(days: string[]): Observable<string> {
    return this.labelPipe.join(days, 'days-of-week', ', ', 7);
  }
}
